var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgImage w-5/6 mx-auto text-white text-2xl"},[_c('h1',{staticClass:"pt-40 text-center"},[_vm._v(_vm._s(_vm.$t('register.verify')))])])}
var staticRenderFns = []

export { render, staticRenderFns }